@if (visible) {
  <nb-card [ngClass]="{'no-shadow': !boxShadow}" nbSpinnerStatus="primary" class="chart-card"
    [style.border]="'none'"
    [style.position]="'relative'">
    @if (loading) {
      <div class="grid-loading-overlay">
        <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
      </div>
    }
    @if (!loading) {
      <ng-container>
        <nb-card-header>
          @if (allowZoom && zoomEnabled) {
            <fa-icon [icon]="['fas', 'search-minus']" class="me-2" (click)="resetZoom()"></fa-icon>
          }
        </nb-card-header>
        <nb-card-body>
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="options"
            [oneToOne]="true"
            (chartInstance)="saveInstance($event)"
            style="display: block;"
            class="chart"
          ></highcharts-chart>
          @if (!hasNotation) {
            <div class="chart-no-data">
              {{ "Awaiting technical evaluation of equipment" | translate}}
            </div>
          }
          @if (alert) {
            <nb-alert [accent]="alert.status" class="chart-alert">
              <div class="chart-alert-title">{{ alert.title}}
                @if (alert.message) {
                  <span (click)="displayAlert()" class="chart-alert-more-info">
                    ({{ 'pages.common.charts.base-chart.more_info' | translate }})
                  </span>
                }
              </div>
            </nb-alert>
          }
        </nb-card-body>
      </ng-container>
    }
  </nb-card>
}

<ng-template #expandedDialog let-data let-ref="dialogRef">
  <nb-card class="expanded-chart-dialog">
    <nb-card-body>
      <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="options"
        [oneToOne]="true"
        style="display: block; width: 100%; height: 85vh;"
      ></highcharts-chart>
    </nb-card-body>
  </nb-card>
</ng-template>

<ng-template #alertDialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>{{ 'pages.common.charts.lifecycle-chart.alert_popup_header' | translate }}</nb-card-header>
    <nb-card-body>{{ alert.message }}</nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="ref.close()">{{'pages.common.charts.base-chart.close' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
